import isTokenValid from 'helpers/custom/functions/isTokenValid'
import { authTokenKey } from 'helpers/custom/tokens'
import { getTokenAndMemberIdFromHash } from 'pages/Login/Login.utils'
import { useMemo } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { routes, appRoutes } from 'routes/routes'
import { dupacoManagementApi } from 'services/api'
import { useAppDispatch, useAppSelector } from 'services/store'
import { selectUser, userAuth, UserData } from 'services/store/slices/userSlice'

export const OriginPathnameKey = 'originPathname'
export type LocationState = {
  hash?: string
  state?: {
    [OriginPathnameKey]?: string
  }
}

export const useAuth = () => {
  const dispatch = useAppDispatch()
  const authState = useAppSelector(selectUser)
  const { state, hash } = useLocation() as LocationState
  const navigate = useNavigate()

  const actions = useMemo(
    () => ({
      login: (token: string) => {
        localStorage.setItem(authTokenKey, token)
        dispatch(userAuth({ isAuth: true, token }))
      },
      become: (urlHash: string) => {
        const { token, memberId } = getTokenAndMemberIdFromHash(urlHash)
        if (token) {
          localStorage.setItem(authTokenKey, token)
          dispatch(userAuth({ isAuth: true, token }))
          navigate(routes.root.path)
        }
      },
      logout: () => {
        localStorage.removeItem(authTokenKey)
        dispatch(userAuth({ isAuth: false }))
        dispatch(dupacoManagementApi.util.resetApiState())
        navigate(appRoutes.login.main)
      },
    }),
    [dispatch]
  )

  const authToken = localStorage.getItem(authTokenKey)

  if (hash) {
    actions.become(hash)
  }

  if (authToken && !authState.isAuth) {
    if (!isTokenValid(authToken)) {
      actions.logout()
      return [authState, actions] as [UserData, typeof actions]
    }
    dispatch(userAuth({ isAuth: true }))
  }

  return [authState, actions] as [UserData, typeof actions]
}
